"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAYOUT_DIRECTION = void 0;
var LAYOUT_DIRECTION;
(function (LAYOUT_DIRECTION) {
    LAYOUT_DIRECTION["ltr"] = "ltr";
    LAYOUT_DIRECTION["rtl"] = "rtl";
})(LAYOUT_DIRECTION || (exports.LAYOUT_DIRECTION = LAYOUT_DIRECTION = {}));
//# sourceMappingURL=interfaces.js.map